__turbopack_context__.v({
  "alignLeft": "ChapterSection-module__H5isKa__alignLeft",
  "alignRight": "ChapterSection-module__H5isKa__alignRight",
  "backgroundVideoContainer": "ChapterSection-module__H5isKa__backgroundVideoContainer",
  "chapterTag": "ChapterSection-module__H5isKa__chapterTag",
  "contentContainer": "ChapterSection-module__H5isKa__contentContainer",
  "descriptionText": "ChapterSection-module__H5isKa__descriptionText",
  "headlineGroup": "ChapterSection-module__H5isKa__headlineGroup",
  "headlineOutline": "ChapterSection-module__H5isKa__headlineOutline",
  "headlineSolid": "ChapterSection-module__H5isKa__headlineSolid",
  "scrollWrapper": "ChapterSection-module__H5isKa__scrollWrapper",
  "stickyPanel": "ChapterSection-module__H5isKa__stickyPanel",
  "textBlock": "ChapterSection-module__H5isKa__textBlock",
});
